export class RFIDTagNamesVM {
    rfidTagId: number;
    tagId: string;
    value : number;
    display : string;
}
